import { fetchWithRetry } from '../../authorisation'
// How frequently to poll the api
const pollDelay = 3000

const polling = (payload, callback) => (dispatch) => (
  setTimeout(() => {
    callAPI(payload, callback, dispatch)
  }, calculateDelay())
)

const callAPI = ({ status_path, jwt }, callback, dispatch) => {

  return fetchWithRetry(
    process.env.REACT_APP_API_HOST + status_path,
    {
      method: 'GET',
      token: jwt,
      jsonAPI: true
    },
    dispatch
  )
    .then(response => (
      response.json()
        .then(payload => (
          response.ok ?
            callback(payload) :
            callback({
              errors: [payload]
            })
        ))
    ))
}

const calculateDelay = () => (
  // So that our tests running times don't blow out
  process.env.NODE_ENV === 'test' ? 0 : pollDelay
)

export default polling


// WEBPACK FOOTER //
// ./src/ui/sync-button/polling.js